// extracted by mini-css-extract-plugin
export var activeThumbnail = "product-hero-v2-module--activeThumbnail--52225";
export var descriptionText = "product-hero-v2-module--descriptionText--26d2d";
export var desktopGallery = "product-hero-v2-module--desktopGallery--cd9b7";
export var desktopRecognition = "product-hero-v2-module--desktopRecognition--b3142";
export var desktopThumbnail = "product-hero-v2-module--desktopThumbnail--2cf51";
export var desktopThumbnails = "product-hero-v2-module--desktopThumbnails--ded22";
export var featureBlock = "product-hero-v2-module--featureBlock--b2367";
export var featureBlocksContainer = "product-hero-v2-module--featureBlocksContainer--7e093";
export var featureDescription = "product-hero-v2-module--featureDescription--aa6ff";
export var featureTitle = "product-hero-v2-module--featureTitle--cb496";
export var galleryContainer = "product-hero-v2-module--galleryContainer--228e3";
export var galleryThumbnail = "product-hero-v2-module--galleryThumbnail--05c20";
export var headerSection = "product-hero-v2-module--headerSection--cc45d";
export var heroImage = "product-hero-v2-module--heroImage--4e4ed";
export var heroImageWrapper = "product-hero-v2-module--heroImageWrapper--14a55";
export var imageContainer = "product-hero-v2-module--imageContainer--7b779";
export var mainImageContainer = "product-hero-v2-module--mainImageContainer--e4839";
export var mainProductSection = "product-hero-v2-module--mainProductSection--3f6b1";
export var mediaLogo = "product-hero-v2-module--mediaLogo--c875b";
export var mediaLogoImage = "product-hero-v2-module--mediaLogoImage--b7c6d";
export var mediaLogoText = "product-hero-v2-module--mediaLogoText--500c3";
export var mediaLogos = "product-hero-v2-module--mediaLogos--3ad1a";
export var mobileGallery = "product-hero-v2-module--mobileGallery--50039";
export var mobileRecognition = "product-hero-v2-module--mobileRecognition--08687";
export var productDescription = "product-hero-v2-module--productDescription--85bf7";
export var productHeroWrapper = "product-hero-v2-module--productHeroWrapper--75a6b";
export var productTitle = "product-hero-v2-module--productTitle--8d255";
export var recognitionSection = "product-hero-v2-module--recognitionSection--d7c99";
export var recognitionTitle = "product-hero-v2-module--recognitionTitle--594bf";
export var star = "product-hero-v2-module--star--df149";
export var subtitleText = "product-hero-v2-module--subtitleText--b4734";
export var thumbnailImage = "product-hero-v2-module--thumbnailImage--05f1a";